import { useState } from "react"
import { useLocation, useNavigate } from "react-router"
import type { SortingState, OnChangeFn } from "@tanstack/react-table"

export const useSortingState = (initialSorting: SortingState = []) => {
  const location = useLocation()
  const navigate = useNavigate()

  const [sorting, setSorting] = useState<SortingState>(
    location.state?.sorting || initialSorting,
  )

  const onSortingChange: OnChangeFn<SortingState> = (updaterOrValue) => {
    const newSorting =
      typeof updaterOrValue === "function"
        ? updaterOrValue(sorting)
        : updaterOrValue

    setSorting(newSorting)

    navigate(".", {
      state: { ...location.state, sorting: newSorting },
      replace: true,
    })
  }

  return { sorting, onSortingChange }
}
